'use client';

import * as Styled from './NoAccessOrganizationList.styled';

import * as React from 'react';

export const NoAccessOrganizationList: React.FC = () => (
  <Styled.BaseOrganizationDiv>
    <Styled.NoAccessContainer>
      <h1>
        You don't belong to any Cribl Organizations
      </h1>
      <ul>
        <li>If your organization uses Cribl, ask an admin to invite you.</li>
        <li>If you'd like to create a new Cribl Organization, <a href='https://cribl.io/contact/' target='_blank' rel='noopener noreferrer'>contact us</a> to learn more. </li>
      </ul>
    </Styled.NoAccessContainer>
  </Styled.BaseOrganizationDiv>
);
